<template>
  <van-row>
    <van-col span="5" class="cell1">{{title}}</van-col>
    <van-col span="19" class="cell2">{{value}}</van-col>
  </van-row>
</template>

<script>
export default {
  name: "valuecell",
  props: {
    title: {
      type: String,
      default: "key"
    },
    value: {
      type: String,
      default: "value"
    }
  }
};
</script>

<style scoped lang="scss">
.cell1 {
  text-align: left;
  line-height: 2.5rem;
  height: 2.5rem;
  background-color: transparent;
  text-overflow: clip;
  overflow: hidden;
}
.cell2 {
  text-align: left;
  line-height: 2.5rem;
  padding-left: 0.5rem;
  background-color: transparent;
  overflow-y: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/valuecell.vue